import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconDropdownArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M7.414 8.5c-.89 0-1.337 1.077-.707 1.707l4.586 4.586c.39.39 1.024.39 1.414 0l4.586-4.586c.63-.63.184-1.707-.707-1.707H7.414z"
	})
});
export default SvgIconDropdownArrowDown;
